import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { LOCATION_INITIALIZED, isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { CoreConfigService } from './core.service';
import { LocalstorageService } from './Localstorage.service';
import { Setting_Model } from './core.model';
import { resolve } from 'dns';

@Injectable({ providedIn: 'root' })
export class StartupService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _injector: Injector
  ) {}
  LoadLang() {
    let _TranslateService = this._injector.get(TranslateService);
    _TranslateService.addLangs(['en', 'th','cn']);
    if (isPlatformBrowser(this.platformId)) {
      let _LocalstorageService = this._injector.get(LocalstorageService);
      let _CoreConfigService = this._injector.get(CoreConfigService);

      try {
        let _path = window.location.pathname;
        let _support_lang = ['th', 'en' , 'cn'];
        let total_path = _path.split('/').filter((s) => s);
        if (total_path.length > 0) {
          let find_lang = _support_lang.find((s) =>
            total_path.some((d) => d == s)
          );
          if (find_lang) _CoreConfigService.Setting.lang = find_lang;
        }
      } catch {}

      _TranslateService.use(_CoreConfigService.Setting.lang);
    }
  }

  GetRuntimeConfig(): Promise<any> {
    let _CoreConfigService = this._injector.get(CoreConfigService);
    if (isPlatformBrowser(this.platformId)) {
      const promise = new Promise<boolean>((resolve, reject) => {
        _CoreConfigService
          .GetConfig()
          .toPromise()
          .then((res) => {
            _CoreConfigService.base_config = res;
            this.LoadLang();
            return res ? resolve(true) : reject();
          })
          .catch((ex) => {
            console.log(ex);
            return reject();
          });
      });
      return promise;
    }
  }
}
